export function NeedsDetailsPill() {
  return (
    <span
      className="nb-pill"
      style={{
        height: 17,
        fontSize: 8.5,
        padding: '0 6px',
        fontWeight: 700,
        letterSpacing: '.05em',
        textTransform: 'uppercase',
        background: 'var(--nb-warn-soft)',
        color: 'var(--nb-warn)',
        borderColor: 'transparent',
      }}
    >
      Needs details
    </span>
  );
}
